package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

@Serializable
data class CalendarImportRowResponse(
    @SerialName("row_number") val rowNumber: Int? = null,
    @SerialName("event_date") val eventDate: String? = null,
    @SerialName("is_all_day") val isAllDay: Boolean? = null,
    @SerialName("from_time") val fromTime: String? = null,
    @SerialName("to_time") val toTime: String? = null,
    @SerialName("event_title") val eventTitle: String? = null,
    @SerialName("event_type") val eventType: String? = null,
    val errors: List<String>? = null
)

@Serializable
data class CalendarImportValidationResponse(
    @SerialName("session_id") val sessionId: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    @SerialName("file_name") val fileName: String? = null,
    @SerialName("total_rows") val totalRows: Int? = null,
    @SerialName("valid_rows") val validRows: Int? = null,
    @SerialName("invalid_rows") val invalidRows: Int? = null,
    @SerialName("valid_payload") val validPayload: List<JsonObject>? = null,
    val errors: List<CalendarImportRowResponse>? = null
)

@Serializable
data class CalendarImportCommitResponse(
    @SerialName("imported_count") val importedCount: Int? = null,
    @SerialName("skipped_count") val skippedCount: Int? = null,
    val errors: List<String>? = null,
    val message: String? = null
)
